import { Box, Paper, Typography } from '@mui/material';

const PersonalDetails = ({
  firstName,
  lastName,
  companyName,
  email
}: {
  firstName: string | null;
  lastName: string | null;
  companyName: string | null;
  email: string | null;
}) => {
  return (
    <Box
      component={Paper}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        width: '100%'
      }}
    >
      <Typography
        fontWeight={700}
        sx={theme => ({
          pb: 1,
          lineHeight: 'normal',
          borderBottom: `1px solid ${theme.palette.text.primary}`
        })}
        variant='subtitle1'
      >
        Personal Details
      </Typography>
      <Box sx={{ display: 'flex', pt: 1 }}>
        <Typography
          sx={{ width: 150, lineHeight: 'normal', fontWeight: 600 }}
          variant='body2'
        >
          First Name
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal', pb: 0.5 }}
          variant='body2'
        >
          {firstName}
        </Typography>{' '}
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Typography
          sx={{ fontWeight: 600, lineHeight: 'normal', width: 150 }}
          variant='body2'
        >
          Last Name
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal', pb: 0.5 }}
          variant='body2'
        >
          {lastName}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Typography
          sx={{ fontWeight: 600, lineHeight: 'normal', width: 150 }}
          variant='body2'
        >
          Company Name
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal', pb: 0.5 }}
          variant='body2'
        >
          {companyName}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Typography
          sx={{ fontWeight: 600, lineHeight: 'normal', width: 150 }}
          variant='body2'
        >
          Email Address
        </Typography>
        <Typography
          sx={{ pl: 1, lineHeight: 'normal', pb: 0.5 }}
          variant='body2'
        >
          {email}
        </Typography>
      </Box>
    </Box>
  );
};

export default PersonalDetails;
